<template>
    <div class="ocene">
        <div class="ocene-header">Oceni članek</div>
        <div class="zvezdice-container">
            <div id="zvezdice" :style="style" >
                <img src="/images/blog/star.png" alt="zvezdica" class="star" @click="oceniClanek(1)" @mouseover="setHoverElement('1')" @mouseleave="setHoverElement('')">
                <img src="/images/blog/star.png" alt="zvezdica" class="star" @click="oceniClanek(2)" @mouseover="setHoverElement('2')" @mouseleave="setHoverElement('')">
                <img src="/images/blog/star.png" alt="zvezdica" class="star" @click="oceniClanek(3)" @mouseover="setHoverElement('3')" @mouseleave="setHoverElement('')">
                <img src="/images/blog/star.png" alt="zvezdica" class="star" @click="oceniClanek(4)" @mouseover="setHoverElement('4')" @mouseleave="setHoverElement('')">
                <img src="/images/blog/star.png" alt="zvezdica" class="star" @click="oceniClanek(5)" @mouseover="setHoverElement('5')" @mouseleave="setHoverElement('')">
            </div>
            <div class="st-glasov" v-cloak>{{ rating }}</div>
        </div>
        <div class="error-message" v-cloak>{{ errorMessage }}</div>
    </div>
</template>

<script>
export default {
    props: ["blog", "token"],
	data() {
		return {
            rating: `Ocena 0 / 0 glasov`,
            result: 0,
            style: undefined,
            hoverElement: '',
            errorMessage: undefined
		};
	},
    mounted() {
        this.loadOcene();
        this.resize();
        window.addEventListener("resize", _.debounce(this.resize, 150));
    },
    methods: {
        loadOcene() {
            axios.get(this.route('blog.get-ocene', this.blog.permalink)).then(({data}) => {
                if (data.status && data.status === "error") {
                    return this.errorMessage = data.message;
                }
                const intermediatesum = data.ocene.reduce((a, b) => parseFloat(a) + parseFloat(b.ocena), 0);
                const nrOcen = data.ocene.length;
                this.result = (intermediatesum / nrOcen) || 0;
                this.rating = `Ocena ${Number(this.result).toFixed(1)} / ${nrOcen} glasov`;
                this.zvezdiceStyle();
            })
            .catch(err => {
                if (err.message) {
                    return this.errorMessage = err.message;
                }
                return this.errorMessage = "Prišlo je do napake, prosim poskusite kasneje."
            });
        },
        oceniClanek(ocena) {
            this.errorMessage = undefined;
            axios.post(this.route('blog.create-ocene', this.blog.permalink), { ocena })
                .then(({data}) => {
                    if (!data) {
                        return console.log("ni podatkov");
                    }
                    if (data.status && data.status === "error") {
                        return this.errorMessage = data.message;
                    }
                    const intermediatesum = data.ocene.reduce((a, b) => parseFloat(a) + parseFloat(b.ocena), 0);
                    const nrOcen = data.ocene.length;
                    this.result = (intermediatesum / nrOcen) || 0;
                    this.rating = `Rating ${Number(this.result).toFixed(1)} / ${nrOcen} glasov`;
                    this.zvezdiceStyle();
            })
            .catch(err => {
                if (err.message) {
                    return this.errorMessage = err.message;
                }
                return this.errorMessage = "Prišlo je do napake, prosim poskusite kasneje."
            });
        },
        zvezdiceStyle() {
            const myObject = document.getElementById("zvezdice")
            const width = this.hoverElement ? myObject.clientWidth * (this.hoverElement / 5) : myObject.clientWidth * (this.result / 5);
            const styleYellow = "rgb(240, 212, 68) " + width + "px 0px 0px 0px inset,";
            const styleGray = "rgb(197, 200, 206)  " + (width - myObject.clientWidth) + "px 0px 0px 0px inset";
            this.style = { "box-shadow": styleYellow + styleGray };
        },
        resize() {
            const myObject = document.getElementById("zvezdice")
            const width = this.hoverElement ? myObject.clientWidth * (this.hoverElement / 5) : myObject.clientWidth * (this.result / 5);
            const styleYellow = "rgb(240, 212, 68) " + width + "px 0px 0px 0px inset" ;
            const styleGray = "rgb(197, 200, 206)  " + (width - myObject.clientWidth) + "px 0px 0px 0px inset";
            this.style = { "box-shadow": styleYellow + styleGray };
        },
        setHoverElement(element) {
            this.hoverElement = element;
            this.zvezdiceStyle();

        }
    }
};
</script>
